import { Box, Stack } from '@mui/material';
import { Caption } from '@telegram-apps/telegram-ui';
import React from 'react';
import { CommonIcon } from './CommonIcon';

export type DotProgressProps = {
  done: number;
  total: number;
  overdue?: boolean;
  maxDots?: number;
  color?: string;
};

export const DotProgress: React.FC<DotProgressProps> = ({
  done,
  total,
  overdue = false,
  maxDots = 6,
  color,
}) => {
  const dots = Math.min(total, maxDots);
  const extra = total > maxDots ? total - maxDots : 0;
  const completedColor = color || (overdue ? 'var(--tg-theme-destructive-text-color)' : 'var(--tgui--button_color)');

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
        {total > 0 && done === total ? (
            <CommonIcon
              icon="check_circle"
              type="filled"
              size={16}
              color={completedColor}
            />
        ): (
            <>
                {Array.from({ length: dots }, (_, i) => (
                    <Box
                      key={i}
                      style={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: i < done
                          ? completedColor
                          : 'var(--tgui--hint_color)',
                      }}
                    />
                ))}
                {extra > 0 && (
                    <Caption style={{ marginLeft: '4px', fontSize: '0.75rem', color: 'var(--tgui--hint_color)' }}>
                    +{extra}
                    </Caption>
                )}
            </>
        )}
    </Stack>
  );
};
